<!-- Delete once component library can be imported -->
<template>
  <div :class="$style.checkboxWrapper">
    <input
      id="rememberMeCheckbox"
      type="checkbox"
      v-model="inputValue"
    >
    <label
      :class="$style.checkboxLabel"
      for="rememberMeCheckbox"
    >
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',

  props: {
    label: {
      type: String,
      default: '',
    },

    value: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
};
</script>

<style module>
.checkboxWrapper {
  align-items: center;
  display: flex;
}

.checkboxLabel {
  margin-left: 0.5rem;
}
</style>
